




























import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { IProductAspectsVariant } from '~/assets/interfaces/products'
import ComponentImage from '~/components/images/image.vue'
@Component({
  components: {
    ComponentImage,
  },
})
export default class ComponentProductAspects extends Vue {
  @Prop({ type: Array, default: [] })
  readonly variants: Partial<IProductAspectsVariant>[]

  private get variantsRender() {
    let num = this.$device.isMobileOrTablet ? 3 : 5
    if (this.variants.find((item) => !!item.image)) {
      num = 7
    }
    const temp = this.variants.slice(0, num)
    if (temp.length < this.variants.length) {
      temp.push({
        title: '+' + (this.variants.length - temp.length),
      })
    }
    return temp
  }
}
